import { Style, Text, Fill } from 'ol/style';

export const text = async (styleDef,layer,__style) => {

	const offsetY = 2 - (styleDef.anchor ? (styleDef.anchor[1] - 0.5) : 0) * styleDef.size

	__style.push(new Style({
		zIndex: styleDef.zIndex,
		text: new Text({
			text: layer.text,
			font: layer.font || 'normal sans-serif 10px',
			offsetY: offsetY,
			textBaseline:"middle", //'bottom', 'top', 'middle', 'alphabetic', 'hanging', 'ideographic'.
			fill: new Fill({
				color: layer.color,
			}),
		}),
	}));
};

export default text;